module.exports = __webpack_public_path__ + "img/signet-leichte-sprache.ae67607c.png";